var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "gfu-header-logo",
      attrs: { title: _vm.platformName, "data-qa": "main-navbar:Logo" },
    },
    [
      _c(
        "a",
        { attrs: { href: _vm.url } },
        [
          _c("themed-image", {
            staticClass: "gfu-header-logo__icon",
            attrs: {
              src: "/content/images/site-icon.svg",
              alt: _vm.platformName,
            },
          }),
          _vm._v(" "),
          _c("themed-image", {
            staticClass: "gfu-header-logo__full",
            attrs: {
              src: "/content/images/static/logo/site-logo.svg",
              alt: _vm.platformName,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }